// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"296":"privacy","717":"pricing","929":"terms"}[chunkId] + "." + {"296":"1d2ed678","717":"bfe2b17f","929":"fd1fcd89"}[chunkId] + ".js";
};